import { useContext } from "react";
import { Card, Row, Col, Typography, Space, Tag } from "antd";
import { FaTicketAlt, FaTrophy } from "react-icons/fa";
import { IGiveawayAuto } from "../../../../../interfaces";
import { convertMoedaBRDoJSNovo } from "../../../../../utils/Conversores";
import { ThemeContext } from "../../../../../contexts/ThemeContext";

const { Text } = Typography;

interface IProps {
    giveawayAutoData?: IGiveawayAuto;
    canViewWinners: boolean;
}

export const WinnersCard = ({ giveawayAutoData, canViewWinners }: IProps) => {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === 'dark';

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {giveawayAutoData?.awards?.map((award, idx) => {
                const { description, value, app_user_auto } = award;
                return (
                    <Card
                        key={idx}
                        type="inner"
                        bordered={false}
                        className="report-card winners-card-item"
                        style={{
                            background: isDark ? '#1f1f1f' : '#f8fafc',
                            border: `1px solid ${isDark ? '#2d2d2d' : '#e2e8f0'}`,
                            borderRadius: 10,
                            marginBottom: 0,
                            boxShadow: 'none',
                        }}
                        headStyle={{
                            borderBottom: `1px solid ${isDark ? '#2d2d2d' : '#e2e8f0'}`,
                            padding: '10px 16px',
                        }}
                        bodyStyle={{
                            padding: '14px 16px',
                        }}
                        title={
                            <Row justify="space-between" align="middle" gutter={[8, 8]}>
                                <Col>
                                    <Space style={{ alignItems: 'center' }} wrap>
                                        <FaTrophy size={18} color="#eab308" />
                                        <Text strong className="section-title" style={{ color: isDark ? '#f1f5f9' : '#0f172a', fontSize: 14 }}>
                                            {description}
                                        </Text>
                                        <Tag color="green" style={{ borderRadius: 6, fontWeight: 700, margin: 0 }}>
                                            R$ {convertMoedaBRDoJSNovo(value)}
                                        </Tag>
                                    </Space>
                                </Col>
                                <Col>
                                    <Space align="center" size={6}>
                                        <Text type="secondary" className="section-label" style={{ fontSize: 12, color: isDark ? '#94a3b8' : '#64748b' }}>
                                            Bilhete:
                                        </Text>
                                        <Tag
                                            color="blue"
                                            style={{
                                                fontSize: 13,
                                                fontWeight: 700,
                                                borderRadius: 6,
                                                margin: 0,
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: 4
                                            }}
                                        >
                                            <FaTicketAlt size={11} />
                                            #{award.winning_ticket_auto_id || '--'}
                                        </Tag>
                                    </Space>
                                </Col>
                            </Row>
                        }
                    >
                        {canViewWinners && app_user_auto ? (
                            <Row gutter={[16, 10]}>
                                <Col span={24}>
                                    <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                                        <Text type="secondary" className="section-label" style={{ fontSize: 12, color: isDark ? '#94a3b8' : '#64748b' }}>
                                            Ganhador:
                                        </Text>
                                        <Text className="section-text" strong style={{ color: isDark ? '#f1f5f9' : '#0f172a' }}>
                                            {app_user_auto.name}
                                        </Text>
                                    </div>
                                </Col>
                            </Row>
                        ) : (
                            <Text type="secondary" style={{ color: isDark ? '#94a3b8' : '#64748b' }}>
                                Nenhum ganhador apurado ainda.
                            </Text>
                        )}
                    </Card>
                );
            })}
        </div>
    );
};

